import { useEffect, useRef, useState, useCallback } from 'react';
import { logout } from '../../reducers/authReducer';
import { useAppSelector, useAppDispatch } from '../../store/store';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';

export const Perfil = ({ screenIsSmall, showBySmall }: { screenIsSmall: boolean, showBySmall: boolean }) => {
  const { primer_nombre, primer_apellido } = useAppSelector(state => state.auth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [alertas, setAlertas] = useState<any[]>([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [ocultas, setOcultas] = useState<Set<string>>(new Set());
  const dropdownRef = useRef<HTMLDivElement>(null);

  const fechaHoy = new Date().toISOString().split('T')[0];
  const storageKey = `alertas_ocultas_${fechaHoy}`;

  const toggleDropdown = () => setDropdownVisible(!dropdownVisible);

  const guardarOcultas = useCallback((nuevas: Set<string>) => {
    localStorage.setItem(storageKey, JSON.stringify(Array.from(nuevas)));
    setOcultas(new Set(nuevas));
  }, [storageKey]);

  const ocultarAlerta = (clave: string) => {
    const nuevas = new Set(ocultas);
    nuevas.add(clave);
    guardarOcultas(nuevas);
  };

  const handleClickNotificacion = (clave: string) => {
    ocultarAlerta(clave);
    setDropdownVisible(false);
    navigate('/alertas-monitoreo');
  };

  const handleCloseAlerta = (e: React.MouseEvent, clave: string) => {
    e.stopPropagation();
    ocultarAlerta(clave);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownVisible(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchAlertas = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('usr') || '{}');
        const token = user?.accessToken || '';

        const response = await axios.post(`${process.env.REACT_APP_API_URL}/peso/alertas-procesadas`, { fecha: fechaHoy }, {
          headers: { Authorization: `Bearer ${token}` }
        });

        const data: any[] = response.data || [];

        const conClaves = data.map((a: any) => ({
          ...a,
          clave: `${a.id}-${a.cupo}-${a.tipo_alerta}-${a.fecha}`
        }));

        setAlertas(conClaves);

        const clavesActuales = new Set<string>(conClaves.map((a: any) => a.clave));
        const guardadas = new Set<string>(JSON.parse(localStorage.getItem(storageKey) || '[]'));
        const filtradas = Array.from(guardadas).filter(k => clavesActuales.has(k));
        guardarOcultas(new Set(filtradas));
      } catch (error) {
        console.error("Error obteniendo alertas:", error);
      }
    };

    fetchAlertas();
  }, [fechaHoy, guardarOcultas, storageKey]);

  const alertasAltas = alertas.filter(a => a.nivel_alerta === 'Alta' && !ocultas.has(a.clave));

  const iconoNotificaciones = (
    <div className="position-relative me-3" style={{ cursor: 'pointer' }} ref={dropdownRef}>
      <i className="bi bi-exclamation-circle text-white" style={{ fontSize: '22px' }} onClick={toggleDropdown}></i>
      {alertasAltas.length > 0 && (
        <span className="position-absolute top-45 start-100 translate-middle badge rounded-pill bg-danger">
          {alertasAltas.length}
        </span>
      )}
      {dropdownVisible && (
        <div className="position-absolute bg-white shadow p-2 mt-2 rounded"
             style={{ right: 0, zIndex: 10, minWidth: '300px', maxHeight: '300px', overflowY: 'auto' }}>
          {alertasAltas.length === 0 ? (
            <div className="text-muted text-center">Sin alertas</div>
          ) : (
            alertasAltas.map((a, idx) => (
              <div
                key={idx}
                className="d-flex align-items-start justify-content-between shadow-sm rounded border-start border-4 border-danger mb-2 p-2"
                style={{ cursor: 'pointer', backgroundColor: '#fff' }}
                onClick={() => handleClickNotificacion(a.clave)}
              >
                <div className="d-flex align-items-center">
                  <i className="bi bi-exclamation-circle me-2 text-danger" style={{ fontSize: '1rem' }}></i>
                  <div className="small fw-bold">Alerta Alta - Cupo {a.cupo}</div>
                </div>
                <button className="btn btn-sm btn-close ms-2" onClick={(e) => handleCloseAlerta(e, a.clave)} />
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );

  return (
    <>
      {screenIsSmall === showBySmall && (screenIsSmall ? (
        <div className="d-flex align-items-center flex-column mt-2 mb-4" style={{ color: '#fff', textAlign: 'center' }}>
          <div className="d-flex justify-content-center mt-4">
            <div className="perfil mx-2">
              <img src="/User_icon_2.png" alt="logo" />
            </div>
            <div className="text-light text-start">
              <div>
                <span>{`${primer_nombre} ${primer_apellido}`}</span>
                <br />
                <a href='/#' className='text-danger text-decoration-none' onClick={(e) => { e.preventDefault(); dispatch(logout()); }}>
                  <span className="icon-switch pe-1"></span>Cerrar Sesión
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="d-flex col-md-4 justify-content-end align-items-center position-relative">
          {iconoNotificaciones}
          <div className="text-light text-end">
            <div>
              <span>{`${primer_nombre} ${primer_apellido}`}</span>
              <br />
              <a href='/#' className='text-danger text-decoration-none' onClick={(e) => { e.preventDefault(); dispatch(logout()); }}>
                <span className="icon-switch pe-1"></span>Cerrar Sesión
              </a>
            </div>
          </div>
          <div className="perfil mx-2">
            <img src="/User_icon_2.png" alt="logo" />
          </div>
        </div>
      ))}
    </>
  );
};
